import { useEffect } from 'react';

export const useRegisterValidationEffect = (
  registerInsuranceValidation: any,
  setters: any
) => {
  const {
    setSuccess,
    setPayPSE,
    setSuccessBadPath,
    setUnHappyPath,
    setManualPath,
    setErrorCaptcha,
    setDefaultError,
    setFileError,
    setSystemError
  } = setters;

  useEffect(() => {
    if (registerInsuranceValidation) {
      switch (registerInsuranceValidation?.codePSE) {
        case 1:
          setSuccess(true);
          break;
        case 2:
          setPayPSE(true);
          break;
        case 3:
          setSuccessBadPath(true);
          break;
        case 4:
          setUnHappyPath(true);
          setManualPath(true);
          break;
        case 5:
          setErrorCaptcha(true);
          break;
        case 6:
          setDefaultError(true);
          break;
        case 7:
          setFileError(true);
          break;
        case 8:
          setSystemError(true);
          break;
        default:
          setDefaultError(true);
          break;
      }
    }
  }, [registerInsuranceValidation]);
};
